// Module
var code = "<div class=\"center\"> <button class=\"btn btn-sm btn-info text-bold btn-primary\" ng-class=\"{'disabled':$ctrl.isSavingEmployment}\"> {{$ctrl.isSavingEmployment ? 'Saving Employment. Please Wait...': 'Save Employment'}} </button> </div> ";
// Exports
module.exports = code;